var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12006",
    "data-name": "Group 12006",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.754,
    height: 15.682,
    viewBox: "0 0 13.754 15.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17057",
    "data-name": "Rectangle 17057",
    width: 13.754,
    height: 15.682,
    fill: "#6676aa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12005",
    "data-name": "Group 12005",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38026",
    "data-name": "Path 38026",
    d: "M3.557,2.618c.93,0,1.86,0,2.79,0a.283.283,0,0,0,.317-.22A3.652,3.652,0,1,1,9.34,7.225a.33.33,0,0,0-.4.157c-.391.553-.809,1.087-1.19,1.646a1.129,1.129,0,0,0-.191.585c-.017,1.207-.014,2.415-.006,3.623a1.193,1.193,0,0,1-.521,1.045c-.521.379-1.033.77-1.542,1.165a.763.763,0,0,1-.879.155.785.785,0,0,1-.4-.8c.007-1.7,0-3.394.006-5.091a1.192,1.192,0,0,0-.243-.748Q2.129,6.447.29,3.927c-.063-.086-.129-.169-.183-.26A.671.671,0,0,1,.6,2.634a4.54,4.54,0,0,1,.562-.015q1.2,0,2.4,0m-2.385.934c.064.1.1.162.143.22,1.133,1.547,2.262,3.1,3.4,4.637a2.075,2.075,0,0,1,.424,1.3c-.008,1.5,0,3,0,4.506v.343c.4-.3.726-.584,1.088-.812a.823.823,0,0,0,.41-.825c-.029-.823-.008-1.648-.01-2.473,0-1.6-.061-1.37.869-2.641l.728-1a3.741,3.741,0,0,1-1.8-3.255ZM10.1,6.384a2.726,2.726,0,1,0-2.742-2.7,2.725,2.725,0,0,0,2.742,2.7",
    transform: "translate(0 -0.001)",
    fill: "#6676aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38027",
    "data-name": "Path 38027",
    d: "M180.43,48.378c.148-.186.249-.336.372-.464.315-.327.575-.374.795-.159s.178.486-.157.814c-.122.119-.257.224-.449.39.212.181.386.316.543.467a.473.473,0,0,1,.074.71.48.48,0,0,1-.728-.072c-.147-.152-.278-.318-.452-.519-.2.211-.34.374-.493.528a.465.465,0,1,1-.654-.64c.156-.153.326-.294.547-.49-.217-.189-.4-.331-.558-.489a.473.473,0,0,1-.051-.693.464.464,0,0,1,.692.042c.16.161.306.336.521.575",
    transform: "translate(-170.321 -45.292)",
    fill: "#6676aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear-filter.3327f08afcfcbc1350283ce75aafb44a.svg";
export { ForwardRef as ReactComponent };